export default __webpack_public_path__ + "static/media/p2023-1.428023a5.jpeg";